import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_kids_room_refresh: FaireThemeEntity = {
  token: "discovery_theme_kids-room-refresh",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Kids' Room Refresh",
  description: "Playful decor for little ones' spaces",
  bgColor: "#E0D8F5",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
